import * as Klaro from "klaro/dist/klaro-no-css";
import { getLanguage } from './common/languages';

const config = {
    "testing": false,
    "lang": getLanguage(),
    "elementID": "klaro",
    "name": "default",
    "status": "inactive",
    "storageMethod": "localStorage",
    "storageName": "klaro",
    "embedded": false,
    "htmlTexts": false,
    "cookieExpiresAfterDays": 60,
    "groupByPurpose": true,
    "purposeOrder": [
        "functional",
        "performance",
        "marketing"
    ],
    "default": false,
    "mustConsent": false,
    "acceptAll": true,
    "hideDeclineAll": true,
    "hideLearnMore": false,
    "disablePoweredBy": true,
    "noticeAsModal": false,
    "styling": {
        "theme": [
            "bottom",
            "light",
            "wide"
        ]
    },
    "translations": {
        en: {
            consentNotice: {
                description: 'Our website and applications use cookies to improve your experience.',
                learnMore: 'Cookie preferences'
            },
            consentModal: {
                title: 'Cookie preferences',
                description: 'Our website and applications use third-party applications and cookies. To protect and manage your privacy you can review and control these apps here.',
            },
            purposes: {
                functional: {
                    title: 'Functional cookies',
                    description: 'These cookies enable the website and our apps to provide enhanced functionality, personalisation and allow you to navigate and use our features.'
                }
            },
            ok: 'Accept all cookies',
            save: 'Save',
            acceptAll: 'Accept all',
            acceptSelected: 'Accept selected'
        },
        de: {
            consentNotice: {
                description: 'Unsere Website und Anwendungen verwenden Cookies, um Ihre Erfahrungen zu verbessern.',
                learnMore: 'Cookie-Einstellungen'
            },
            consentModal: {
                title: 'Cookie-Einstellungen',
                description: 'Unsere Website und Anwendungen verwenden Anwendungen und Cookies von Drittanbietern. Um Ihre Privatsphäre zu schützen und zu verwalten, können Sie diese Anwendungen hier überprüfen und kontrollieren.',
            },
            purposes: {
                functional: {
                    title: 'Funktionale Cookies',
                    description: 'Diese Cookies ermöglichen es der Website, Verbesserungen und Personalisierungen anzubieten. Darüber hinaus ermöglichen Ihnen die Cookies die Navigation auf der Website und die Nutzung ihrer Funktionen.'
                }
            },
            ok: 'Alle Cookies akzeptieren',
            save: 'Speichern',
            acceptAll: 'Alle akzeptieren',
            acceptSelected: 'Akzeptieren ausgewählt'
        },
        fr: {
            consentNotice: {
                description: 'Notre site web et nos applications utilisent des cookies pour améliorer votre expérience.',
                learnMore: 'Préférences de cookies'
            },
            consentModal: {
                title: 'Préférences de cookies',
                description: 'Notre site web et nos applications utilisent des applications et des cookies tiers. Pour protéger et gérer votre vie privée, vous pouvez consulter et contrôler ces applications ici.',
            },
            purposes: {
                functional: {
                    title: 'Cookies fonctionnels',
                    description: 'Ces cookies permettent au site d\'offrir des améliorations et une personnalisation. En outre, les cookies vous permettent de naviguer sur le site et d\'utiliser ses fonctionnalités.'
                }
            },
            ok: 'Accepter tous les cookies',
            save: 'Sauvegarder',
            acceptAll: 'Accepter tous',
            acceptSelected: 'Accepter la sélection'
        },
        nl: {
            consentNotice: {
                description: 'Onze website en applicaties gebruiken cookies om uw ervaring te verbeteren.',
                learnMore: 'Cookievoorkeuren'
            },
            consentModal: {
                title: 'Cookievoorkeuren',
                description: 'Onze website en applicaties maken gebruik van applicaties en cookies van derden. Om uw privacy te beschermen en te beheren kunt u deze applicaties hier bekijken en beheren.',
            },
            purposes: {
                functional: {
                    title: 'Funktionele Cookies',
                    description: 'Deze cookies zorgen dat de site verbeteringen en personalisatie kan bieden. Daarnaast laten de cookies toe om te navigeren doorheen de site en de functionaliteiten te gebruiken.'
                }
            },
            ok: 'Accepteer alle cookies',
            save: 'Opslaan',
            acceptAll: 'Accepteer alles',
            acceptSelected: 'Accepteer selectie'
        },
        "nl-be": {
            consentNotice: {
                description: 'Onze website en applicaties gebruiken cookies om uw ervaring te verbeteren.',
                learnMore: 'Cookievoorkeuren'
            },
            consentModal: {
                title: 'Cookievoorkeuren',
                description: 'Onze website en applicaties maken gebruik van applicaties en cookies van derden. Om uw privacy te beschermen en te beheren kunt u deze applicaties hier bekijken en beheren.',
            },
            purposes: {
                functional: {
                    title: 'Funktionele Cookies',
                    description: 'Deze cookies zorgen dat de site verbeteringen en personalisatie kan bieden. Daarnaast laten de cookies toe om te navigeren doorheen de site en de functionaliteiten te gebruiken.'
                }
            },
            ok: 'Accepteer alle cookies',
            save: 'Opslaan',
            acceptAll: 'Accepteer alles',
            acceptSelected: 'Accepteer selectie'
        },
        hu: {
            consentNotice: {
                description: 'Weboldalunk és alkalmazásaink Sütiket használnak a felhasználói élmény javítása érdekében.',
                learnMore: 'Cookie preferenciák'
            },
            consentModal: {
                title: 'Cookie preferenciák',
                description: 'Weboldalunk és alkalmazásaink harmadik féltől származó alkalmazásokat és Sütiket használnak. Adatai védelme és kezelése érdekében ezeket az alkalmazásokat itt tekintheti át és ellenőrizheti.',
            },
            purposes: {
                functional: {
                    title: 'Funkcionális Sütik',
                    description: 'Ezek a Sütik lehetővé teszik, hogy a webhely fejlesztéseket és személyre szabást kínáljon. Ezen túlmenően a Sütik lehetővé teszik a webhelyen való navigálást és a funkciók használatát.'
                }
            },
            ok: 'Minden cookie elfogadása',
            save: 'Save',
            acceptAll: 'Minden Sütit elfogadok',
            acceptSelected: 'Kiválasztott Sütik elfogadása'
        },
    },
    "services": [
        {
            "name": "Intercom",
            "translations": {
                "en": {
                    "description": "Intercom is a customer messaging platform. These cookies are required, and are used to enable the site, application and core functionalities."
                },
                "de": {
                    "description": "Intercom ist eine Plattform für Kundennachrichten. Diese Cookies sind erforderlich und werden verwendet, um die Website, die Anwendung und die Kernfunktionalitäten zu ermöglichen."
                },
                "fr": {
                    "description": "Intercom est une plateforme de messagerie client. Ces cookies sont nécessaires, et sont utilisés pour permettre le site, l'application et les fonctionnalités de base."
                },
                "nl": {
                    "description": "Intercom is een platform voor berichten van klanten. Deze cookies zijn verplicht, en worden gebruikt om de site, applicatie en kernfunctionaliteiten mogelijk te maken."
                },
                "nl-be": {
                    "description": "Intercom is een platform voor berichten van klanten. Deze cookies zijn verplicht, en worden gebruikt om de site, applicatie en kernfunctionaliteiten mogelijk te maken."
                },
                "hu": {
                    "description": "Az Intercom egy ügyfél-üzenetküldő platform. Ezek a Sütik szükségesek, és a webhely, az alkalmazás és az alapvető funkciók engedélyezéséhez használatosak."
                },
                "zz": {
                    "title": "Intercom"
                }
            },
            "purposes": [
                "functional"
            ],
            "required": true,
            "cookies": [
                [/^intercom-session.*$/, '/', '.mateco.eu'],
                [/^intercom-session.*$/, '/', '.mymateco.nl'],
                [/^intercom-session.*$/, '/', '.mymateco.de'],
                [/^intercom-session.*$/, '/', '.mymateco.hu'],
                [/^intercom-session.*$/, '/', '.mytvhequipment.com']

            ],
            "optOut": false,
            "onlyOnce": true
        },
        {
            "name": "gtm",
            "title": "Google Tag Manager",
            "translations": {
                "en": {
                    "description": "Google Analytics is a web analytics service that tracks and reports website traffic."
                },
                "de": {
                    "description": "Google Analytics ist ein Webanalysedienst, der den Website-Verkehr verfolgt und meldet."
                },
                "fr": {
                    "description": "Google Analytics est un service d'analyse Web qui permet de suivre et de signaler le trafic sur un site Web."
                },
                "nl": {
                    "description": "Google Analytics is een webanalysedienst die websiteverkeer bijhoudt en rapporteert."
                },
                "nl-be": {
                    "description": "Google Analytics is een webanalysedienst die websiteverkeer bijhoudt en rapporteert."
                },
                "hu": {
                    "description": "A Google Analytics egy webanalitikai szolgáltatás, amely nyomon követi és jelenti a webhelyek forgalmát."
                },
                "zz": {
                    "title": "Google Analytics"
                }
            },
            "purposes": [
                "functional"
            ],
            "required": false,
            "cookies": [
                [/^_g[aid].*$/, '/', '.mateco.eu'],
                [/^_g[aid].*$/, '/', '.mymateco.nl'],
                [/^_g[aid].*$/, '/', '.mymateco.de'],
                [/^_g[aid].*$/, '/', '.mymateco.hu'],
                [/^_g[aid].*$/, '/', '.mymateconl.local'],
                [/^_g[aid].*$/, '/', '.mytvhequipment.com']
            ],
            "optOut": false,
            "onlyOnce": true
        },
        {
            "name": "hotjar",
            "title": "Hotjar",
            "translations": {
                "en": {
                    "description": "Hotjar is an analysis tool to gather qualitative data on user behavior."
                },
                "de": {
                    "description": "Hotjar ist ein Analysetool zum Sammeln qualitativer Daten über das Nutzerverhalten"
                },
                "fr": {
                    "description": "Hotjar est un outil d'analyse permettant de recueillir des données qualitatives sur le comportement des utilisateurs."
                },
                "nl": {
                    "description": "Hotjar is een analysetool om kwalitatieve gegevens over gebruikersgedrag te verzamelen."
                },
                "nl-be": {
                    "description": "Hotjar is een analysetool om kwalitatieve gegevens over gebruikersgedrag te verzamelen."
                },
                "hu": {
                    "description": "A Hotjar egy elemző eszköz, amely minőségi adatokat gyűjthet a felhasználói viselkedésről."
                },
                "zz": {
                    "title": "Hotjar"
                }
            },
            "purposes": [
                "functional"
            ],
            "required": false,
            "cookies": [
                [/^_hj.*$/, '/', '.mateco.eu'],
                [/^_hj.*$/, '/', '.mymateco.nl'],
                [/^_hj.*$/, '/', '.mymateco.de'],
                [/^_hj.*$/, '/', '.mymateco.hu'],
                [/^_hj.*$/, '/', '.mytvhequipment.com'],
                [/^.*$/, '/', 'vars.hotjar.com'],
            ],
            "optOut": false,
            "onlyOnce": true
        }
    ],
    "modified": true
};

window.klaro = Klaro;
window.klaroConfig = config;
Klaro.setup(config);
if (!localStorage.getItem('klaro')) {
    Klaro.show();
}

function openKlaroDialog() {
    Klaro.show();
    setTimeout(setCheckboxes)
}

function setCheckboxes() {
    const manager = Klaro.getManager();
    manager.loadConsents();
}

window.openKlaroDialog = openKlaroDialog;
